<template>
  <div class="search" v-loading.fullscreen.lock="fullLoading">

    <div class="block">
      <div class="block-head">
        {{$t('Reservation Search')}}
      </div>
      <div class="block-content">
        <el-form :inline="true" :model="formInline" :rules="rules" ref="searchOrderForm" class="demo-form-inline">
          <el-form-item :label="$t('Confirmation Number')" prop="confirmNumber">
            <el-input
              v-model.number="formInline.confirmation_number"
              :name="formInline.confirmation_number"
              :placeholder="$t('Confirmation Number')"/>
          </el-form-item>

          <el-form-item :label="$t('First Name')" prop="name">
            <el-input v-model="formInline.first_name" :placeholder="$t('First Name')"/>
          </el-form-item>
          <el-form-item :label="$t('Last Name')" prop="name">
            <el-input v-model="formInline.last_name" :placeholder="$t('Last Name')"/>
          </el-form-item>

          <el-form-item :label="$t('Stay Date')" prop="staydate">
            <el-date-picker
              v-model="formInline.staydate"
              format="MM/dd/yyyy"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('Stay Date')">
            </el-date-picker>
            <span class="format">{{ formInline.staydate | dateFormat(that)}}</span>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('searchOrderForm')">{{$t('Search')}}</el-button>
          </el-form-item>
        </el-form>


      </div>
    </div>
    <div class="block">
      <div class="block-head">
        {{$t('Search Result')}}
      </div>
      <div class="block-content">
        <div class="table-wrapper">
          <table class="table" v-if="orderList.length>0">
            <thead>
            <tr>
              <th class="col name">{{$t('Name')}}</th>
              <th class="col arrival-date">{{$t('Arrival Date')}}
              </th>
              <th class="col departure-date">{{$t('Departure Date')}}
              </th>
              <th class="col confirmation-number">{{$t('Confirmation Number')}}
              </th>
              <th class="col hotel">{{$t('hotel')}}</th>
              <th class="col room-type">{{$t('Room Type')}}</th>
              <th class="col booking-date">{{$t('Booking Date')}}</th>
              <th class="col status">{{$t('Status')}}</th>
              <th class="col action">{{$t('Action')}}</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="(list, key) in orderList" :key='key'>
              <td class="col name">{{list.first_name + ' '+ list.last_name}}</td>
              <td class="col arrival-date">{{list.arrival_date}}</td>
              <td class="col departure-date">{{list.departure_date}}</td>
              <td class="col confirmation-number">{{list.confirmation_number}}</td>
              <td class="col hotel">{{list.hotel}}</td>
              <td class="col room-type">{{list.room_tye}}</td>
              <td class="col booking-date">{{list.booking_date}}</td>
              <td class="col status">{{list.status}}</td>
              <td class="col action">
                <div class="table-toolbar">
                  <router-link :to="{path:'/orders/view/',query: {confirmation_number: list.confirmation_number}}">
                    {{$t('View')}}
                  </router-link>
                  <el-button v-if="list.status==='RESERVED'" type="text"
                             @click="cancelOrder(list.confirmation_number, key)">{{$t('Cancel Booking')}}
                  </el-button>
                </div>
              </td>
            </tr>

            </tbody>
          </table>
          <p v-else>{{$t('No items')}}</p>
          <div class="pager" v-if="last_page>1">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="getList"
              :current-page.sync="formInline.page"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import util from '../../util'

  export default {
    name: "search",
    data() {
      return {
        confirmNote: this.$t('Are you sure to cancel this booking?'),
        formInline: {
          confirmation_number: '',
          last_name: '',
          first_name: '',
          staydate: '',
          page: ''
        },
        rules: {
          confirmation_number: [
            {required: false, message: this.$t('Please enter confirmation number'), trigger: 'change'}
          ],
          first_name: [
            {required: false, message: this.$t('Please enter first name'), trigger: 'change'},
          ],
          last_name: [
            {required: false, message: this.$t('Please enter last name'), trigger: 'change'},
          ],
          staydate: [
            {required: false, message: this.$t('Please enter stay date'), trigger: 'change'}
          ]
        },
        orderList: {},
        last_page: 1,
        total: 0,
        fullLoading: false
      }
    },


    methods: {

      /**
       * submit form
       *
       * **/
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.formInline.confirmation_number || this.formInline.first_name || this.formInline.last_name || this.formInline.staydate) {
              let query = {
                confirmation_number: this.formInline.confirmation_number,
                first_name: this.formInline.first_name,
                last_name: this.formInline.last_name,
                staydate: this.formInline.staydate,
              }
              Object.entries(query).forEach((param) => {
                if (!param[1]) {
                  delete query[param[0]]
                }
              })

              if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
                this.$router.replace('/refresh')
                return
              }



              this.$router.replace({
                'path': '/orders/search', query
              }).then(() => {
                this.getList();
              })
            } else {
              this.$message.error(this.$t('Please enter search items'))
            }
          } else {
            return false;
          }
        });
      },

      /**
       * cancel order
       * **/
      cancelOrder(confirmNumber, key) {
        const h = this.$createElement;
        let vm = this;
        let currOrder = this.orderList[key];
        this.$msgbox({
          title: '',
          message:
            h('div', null, [
              h('p', null, this.confirmNote),
              h('ul', null, [
                h('li', null, currOrder.first_name + " " + currOrder.last_name),
                h('li', null, currOrder.hotel),
                h('li', null, util.dateFormat(currOrder.arrival_date) + '-' + util.dateFormat(currOrder.departure_date)),
                h('li', null, currOrder.room_tye)
              ]),
            ]),
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('No'),
          type: 'warning',
          center: true
        }).then(() => {
          this.fullLoading = true;
          vm.axios.post('/api/junket/order/cancel', {
            confirmation_number: confirmNumber
          }).then(function (res) {
              if (res.code === 200) {
                vm.$message({
                  type: 'success',
                  message: res.msg
                });
                vm.orderList[key].status = 'CANCELED'
              } else {
                vm.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            }
          ).finally(function () {
            vm.fullLoading = false
          })
        }).catch(() => {

        });
      },

      /**
       *
       * get order list
       * **/
      getList(page) {
        let query = {
          ...this.$route.query,
        }
        if (page) {
          query.page = page
          this.$router.replace({
            'path': '/orders/search', query
          })
        }
        const loading = this.$loading({
          fullscreen: true,
          background: 'rgba(0, 0, 0, 0.7)',
          spinner: 'el-icon-loading',
          text: 'Loading'
        })
        this.axios.get('/api/junket/order/list', {
          params: {
            ...this.$route.query,
            limit: 10
          }
        }).then((res) => {
            if (res.code === 200) {
              this.orderList = res.data.data;
              this.formInline.page = res.data.current_page;
              this.last_page = res.data.last_page
              this.total = res.data.total
            } else {
              this.$message.error(res.msg);
            }
          }
        ).finally(() => {
          loading.close();
        })
      },
      initDate() {
        Object.assign(this.formInline, this.$route.query)
      }
    },
    created() {
      this.initDate()
      this.getList()
    }
  }
</script>

